import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { ResetPassword } from '../actions/forgot-password';

import * as fromReset from '../reducers';

@Component({
  selector: 'spaq-reset-password-page',
  template: `
    <h1>Mot de passe perdu</h1>
    <spaq-reset-password (onSubmit)="submit($event)"
                         [code]="code"
                         [pending]="pending$ | async"
                         [error]="error$ | async"
                         [formData]="form$ | async"></spaq-reset-password>
  `,
  styles: [],
})
export class ResetPasswordPageComponent implements OnInit {
  code: string;
  error$ = this.store.select(fromReset.getResetPasswordPageError);
  form$ = this.store.select(fromReset.getResetPasswordPageForm);
  pending$ = this.store.select(fromReset.getResetPasswordPagePending);

  constructor(private route: ActivatedRoute, private store: Store<any>) {
  }

  submit($event) {
    this.store.dispatch(new ResetPassword($event, this.code))
  }

  ngOnInit() {
    this.code = this.route.snapshot.queryParams['oobCode'];
  }

}



// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/auth/forgot-password/containers/reset-password-page.component.ts